/** Higher groups shown in the Checkmate filter. */
export const CHECKMATE_CATEGORIES = [
  { id: 'opening-traps', label: 'Opening Traps' },
  { id: 'back-rank', label: 'Back Rank and Corridors' },
  { id: 'rook-knight', label: 'Rook and Knight' },
  { id: 'queen', label: 'Queen Pictures' },
  { id: 'two-bishops', label: 'Two Bishops' },
  { id: 'knight', label: 'Knight Mates' },
  { id: 'heavy', label: 'Two Heavy Pieces' },
  { id: 'pawn', label: 'Pawn Mates' },
  { id: 'endgame', label: 'Technical Endgame Mates' },
] as const;

export type CheckmateCategory = (typeof CHECKMATE_CATEGORIES)[number]['id'];
export type CheckmateFilter = 'all' | CheckmateCategory;

export function isCheckmateCategory(value: string): value is CheckmateCategory {
  return CHECKMATE_CATEGORIES.some((c) => c.id === value);
}
